import React from 'react';

import { Controller } from 'react-hook-form';
import Calendar from '../Calendar/Calendar';

const ControlledCalendar = props => {
  const { name, control, tileDisabled, disabled, ...rest } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ onChange, value }) => (
        <Calendar
          tileDisabled={tileDisabled}
          value={value}
          onChange={onChange}
          disabled={disabled}
          {...rest}
        />
      )}
    />
  );
};

export default ControlledCalendar;
